import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "toast-icon" }, null, -1)
const _hoisted_3 = { class: "toast-message" }
const _hoisted_4 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "toast",
      class: _normalizeClass(['toast-' + _ctx.type, "toast hide d-print-none"]),
      role: "status"
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.header), 1),
        (_ctx.showCloseButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "toast-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
            }, "Luk"))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("p", null, null, 512), [
          [_directive_dompurify_html, _ctx.message]
        ]),
        _renderSlot(_ctx.$slots, "footer")
      ])
    ], 2)
  ]))
}